<template>
    <div id="app" class="app fond">
         <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages">
                    <section class="Fiche">
                        <div class="Infos Contact">
                            <table class="Tableau-Fiche Contact">
                                <tbody>
                                    <tr>
                                        <th colspan="2" class="colspandeux"><h6>Accessibilité</h6></th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30" class="logo-type-contact fill">
                                                <path id="Icon_material-place" data-name="Icon material-place" d="M18,3A10.492,10.492,0,0,0,7.5,13.5C7.5,21.375,18,33,18,33S28.5,21.375,28.5,13.5A10.492,10.492,0,0,0,18,3Zm0,14.25a3.75,3.75,0,1,1,3.75-3.75A3.751,3.751,0,0,1,18,17.25Z" transform="translate(-7.5 -3)"/>
                                            </svg>
                                        </th>
                                        <th>
                                            <a :href="Bibliotheque.acf.lien_adresse">{{Bibliotheque.acf.adresse}}</a>
                                            <br>
                                            <i>{{Bibliotheque.acf.complement_dadresse}}</i>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <iframe class="contenu-droit-page" :src="Bibliotheque.acf.lien_adresse_iframe" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </section>
                    <section class="Fiche">
                        <section class="Infos" >                                
                            <h6>Contact</h6>
                            <div class="flex-Carte">
                                <br>
                                <div v-for="contact in Bibliotheque.acf.contact" :key="contact.ID" class="TableContactBiblio" style="display: flex">
                                    <div v-for="elu in listeElus" :key="elu.id" >
                                        <div v-if="elu.id == contact.ID" class="carte-conseiller">
                                            <div>
                                                <img :src="elu.image" class="portrait-conseiller" :alt="elu.nom">
                                            </div>

                                            <section class="contenu-carte">
                                                <h5>{{elu.prenom}} {{elu.nom}}</h5>
                                                <a :href="'tel:'+elu.telephone" v-if="elu.telephone != ''"><i>{{elu.telephone}}</i></a>
                                                <br v-if="elu.email != '' || elu.telephone != ''">
                                                <a :href="'mailto:'+elu.email" v-if="elu.email != ''"><i>{{elu.email}}</i></a>
                                            </section>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </section>
                        <div class="contenu-droit-page">
                            <iframe src="https://calendar.google.com/calendar/embed?height=600&wkst=2&bgcolor=%23b0badb&ctz=Europe%2FParis&mode=MONTH&title=Salle%20des%20f%C3%AAtes&src=b3JnNnBrN3NjZGNrYm5jdG5vOWliMmFraThAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&src=bHFzOTBnaG1kbjdxY3N2cjczazBsMmwwcjBAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&color=%230B8043&color=%23D50000" class="AgendaSdF" style="border: 0" width="100%" height="100%" frameborder="0" scrolling="no"w></iframe>

                            <iframe src="https://calendar.google.com/calendar/u/0/embed?src=lqs90ghmdn7qcsvr73k0l2l0r0@group.calendar.google.com&ctz=Europe/Paris" class="AgendaSdF" style="border: 0" width="100%" height="100%" frameborder="0" scrolling="no"></iframe>
                        </div>
                    </section>
                    
                    <section class="Fiche">
                        <section class="Infos">
                            <table class="Tableau-Fiche">
                                <tbody>
                                    <tr>
                                        <th colspan="3" class="colspandeux"><h6>Tarifs de location</h6></th>
                                    </tr>
                                    <tr v-for="jour in Bibliotheque.acf.horaires.body" :key="jour.id">
                                        <th v-for="colonne in jour" :key="colonne.id">{{colonne.c}}</th>
                                    </tr>
                                    <tr>
                                        <th colspan="3" class="colspandeux"><p>{{Bibliotheque.acf.caution}}</p></th>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <div class="contenu-droit-page">
                            <iframe :src="Bibliotheque.acf.contrat" height="100%" width="100%"></iframe>
                        </div>
                    </section>

                    <!--<section>
                        <h3>Ajoutez votre avis</h3>
                        <form class="form-avis" @submit.prevent="creer">
                            <input class="input" type="text" v-model="titre_avis" required placeholder="Titre de votre avis">
                            <br class="form-tel">
                            <input class="input" required type="date" v-model="date_loc" placeholder="Date de location">
                            <div class="input note">
                                <p>Donnez une note</p>
                                <div class="etoiles">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="31.5" height="29.25" viewBox="0 0 31.5 29.25">
                                        <path id="Icon_ionic-ios-star-outline" data-name="Icon ionic-ios-star-outline" d="M32.555,13.5H22.212L19.069,4.12a1.139,1.139,0,0,0-2.138,0L13.788,13.5H3.375A1.128,1.128,0,0,0,2.25,14.625a.827.827,0,0,0,.021.19,1.081,1.081,0,0,0,.471.795l8.5,5.991L7.98,31.085a1.128,1.128,0,0,0,.387,1.266A1.088,1.088,0,0,0,9,32.625a1.378,1.378,0,0,0,.7-.253L18,26.459l8.3,5.913a1.318,1.318,0,0,0,.7.253,1.01,1.01,0,0,0,.626-.274,1.114,1.114,0,0,0,.387-1.266L24.75,21.6l8.43-6.047.2-.176a1.18,1.18,0,0,0,.366-.752A1.191,1.191,0,0,0,32.555,13.5ZM23.611,20a1.975,1.975,0,0,0-.717,2.236l2.116,6.166a.282.282,0,0,1-.429.323l-5.442-3.881a1.965,1.965,0,0,0-1.146-.366,1.928,1.928,0,0,0-1.139.366l-5.442,3.874a.281.281,0,0,1-.429-.323L13.1,22.233a1.981,1.981,0,0,0-.724-2.25l-5.7-4.015a.283.283,0,0,1,.162-.513h6.94a1.966,1.966,0,0,0,1.863-1.343l2.081-6.2a.283.283,0,0,1,.534,0l2.081,6.2A1.966,1.966,0,0,0,22.2,15.455h6.841a.278.278,0,0,1,.162.506Z" transform="translate(-2.25 -3.375)"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="31.5" height="29.25" viewBox="0 0 31.5 29.25">
                                        <path id="Icon_ionic-ios-star-outline" data-name="Icon ionic-ios-star-outline" d="M32.555,13.5H22.212L19.069,4.12a1.139,1.139,0,0,0-2.138,0L13.788,13.5H3.375A1.128,1.128,0,0,0,2.25,14.625a.827.827,0,0,0,.021.19,1.081,1.081,0,0,0,.471.795l8.5,5.991L7.98,31.085a1.128,1.128,0,0,0,.387,1.266A1.088,1.088,0,0,0,9,32.625a1.378,1.378,0,0,0,.7-.253L18,26.459l8.3,5.913a1.318,1.318,0,0,0,.7.253,1.01,1.01,0,0,0,.626-.274,1.114,1.114,0,0,0,.387-1.266L24.75,21.6l8.43-6.047.2-.176a1.18,1.18,0,0,0,.366-.752A1.191,1.191,0,0,0,32.555,13.5ZM23.611,20a1.975,1.975,0,0,0-.717,2.236l2.116,6.166a.282.282,0,0,1-.429.323l-5.442-3.881a1.965,1.965,0,0,0-1.146-.366,1.928,1.928,0,0,0-1.139.366l-5.442,3.874a.281.281,0,0,1-.429-.323L13.1,22.233a1.981,1.981,0,0,0-.724-2.25l-5.7-4.015a.283.283,0,0,1,.162-.513h6.94a1.966,1.966,0,0,0,1.863-1.343l2.081-6.2a.283.283,0,0,1,.534,0l2.081,6.2A1.966,1.966,0,0,0,22.2,15.455h6.841a.278.278,0,0,1,.162.506Z" transform="translate(-2.25 -3.375)"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="31.5" height="29.25" viewBox="0 0 31.5 29.25">
                                        <path id="Icon_ionic-ios-star-outline" data-name="Icon ionic-ios-star-outline" d="M32.555,13.5H22.212L19.069,4.12a1.139,1.139,0,0,0-2.138,0L13.788,13.5H3.375A1.128,1.128,0,0,0,2.25,14.625a.827.827,0,0,0,.021.19,1.081,1.081,0,0,0,.471.795l8.5,5.991L7.98,31.085a1.128,1.128,0,0,0,.387,1.266A1.088,1.088,0,0,0,9,32.625a1.378,1.378,0,0,0,.7-.253L18,26.459l8.3,5.913a1.318,1.318,0,0,0,.7.253,1.01,1.01,0,0,0,.626-.274,1.114,1.114,0,0,0,.387-1.266L24.75,21.6l8.43-6.047.2-.176a1.18,1.18,0,0,0,.366-.752A1.191,1.191,0,0,0,32.555,13.5ZM23.611,20a1.975,1.975,0,0,0-.717,2.236l2.116,6.166a.282.282,0,0,1-.429.323l-5.442-3.881a1.965,1.965,0,0,0-1.146-.366,1.928,1.928,0,0,0-1.139.366l-5.442,3.874a.281.281,0,0,1-.429-.323L13.1,22.233a1.981,1.981,0,0,0-.724-2.25l-5.7-4.015a.283.283,0,0,1,.162-.513h6.94a1.966,1.966,0,0,0,1.863-1.343l2.081-6.2a.283.283,0,0,1,.534,0l2.081,6.2A1.966,1.966,0,0,0,22.2,15.455h6.841a.278.278,0,0,1,.162.506Z" transform="translate(-2.25 -3.375)"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="31.5" height="29.25" viewBox="0 0 31.5 29.25">
                                        <path id="Icon_ionic-ios-star-outline" data-name="Icon ionic-ios-star-outline" d="M32.555,13.5H22.212L19.069,4.12a1.139,1.139,0,0,0-2.138,0L13.788,13.5H3.375A1.128,1.128,0,0,0,2.25,14.625a.827.827,0,0,0,.021.19,1.081,1.081,0,0,0,.471.795l8.5,5.991L7.98,31.085a1.128,1.128,0,0,0,.387,1.266A1.088,1.088,0,0,0,9,32.625a1.378,1.378,0,0,0,.7-.253L18,26.459l8.3,5.913a1.318,1.318,0,0,0,.7.253,1.01,1.01,0,0,0,.626-.274,1.114,1.114,0,0,0,.387-1.266L24.75,21.6l8.43-6.047.2-.176a1.18,1.18,0,0,0,.366-.752A1.191,1.191,0,0,0,32.555,13.5ZM23.611,20a1.975,1.975,0,0,0-.717,2.236l2.116,6.166a.282.282,0,0,1-.429.323l-5.442-3.881a1.965,1.965,0,0,0-1.146-.366,1.928,1.928,0,0,0-1.139.366l-5.442,3.874a.281.281,0,0,1-.429-.323L13.1,22.233a1.981,1.981,0,0,0-.724-2.25l-5.7-4.015a.283.283,0,0,1,.162-.513h6.94a1.966,1.966,0,0,0,1.863-1.343l2.081-6.2a.283.283,0,0,1,.534,0l2.081,6.2A1.966,1.966,0,0,0,22.2,15.455h6.841a.278.278,0,0,1,.162.506Z" transform="translate(-2.25 -3.375)"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="31.5" height="29.25" viewBox="0 0 31.5 29.25">
                                        <path id="Icon_ionic-ios-star-outline" data-name="Icon ionic-ios-star-outline" d="M32.555,13.5H22.212L19.069,4.12a1.139,1.139,0,0,0-2.138,0L13.788,13.5H3.375A1.128,1.128,0,0,0,2.25,14.625a.827.827,0,0,0,.021.19,1.081,1.081,0,0,0,.471.795l8.5,5.991L7.98,31.085a1.128,1.128,0,0,0,.387,1.266A1.088,1.088,0,0,0,9,32.625a1.378,1.378,0,0,0,.7-.253L18,26.459l8.3,5.913a1.318,1.318,0,0,0,.7.253,1.01,1.01,0,0,0,.626-.274,1.114,1.114,0,0,0,.387-1.266L24.75,21.6l8.43-6.047.2-.176a1.18,1.18,0,0,0,.366-.752A1.191,1.191,0,0,0,32.555,13.5ZM23.611,20a1.975,1.975,0,0,0-.717,2.236l2.116,6.166a.282.282,0,0,1-.429.323l-5.442-3.881a1.965,1.965,0,0,0-1.146-.366,1.928,1.928,0,0,0-1.139.366l-5.442,3.874a.281.281,0,0,1-.429-.323L13.1,22.233a1.981,1.981,0,0,0-.724-2.25l-5.7-4.015a.283.283,0,0,1,.162-.513h6.94a1.966,1.966,0,0,0,1.863-1.343l2.081-6.2a.283.283,0,0,1,.534,0l2.081,6.2A1.966,1.966,0,0,0,22.2,15.455h6.841a.278.278,0,0,1,.162.506Z" transform="translate(-2.25 -3.375)"/>
                                    </svg>
                                </div>
                            </div>
                            <textarea class="input-text-area" v-model="commentaire_avis" required name="avis" id="avissallefete" cols="30" rows="10" placeholder="Donnez votre avis"></textarea>
                            <button type="submit" class="boutonSubmit">
                                <span>ENVOYEZ</span>
                            </button>
                        </form>
                    </section>-->
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'SalleFete',
    data () {
        return{
            Bibliotheque:{
                id:0,
                acf:{
                    adresse: null,
                    complement_adresse: null,
                    lien_adresse: null,
                    lien_adresse_iframe: null,                
                    horaires:{},
                    image: {
                        id:0,
                        url:null
                    },
                    visuels: {},
                    logo:{},
                    contact: null,
                    contrat: null,
                    caution: null,
                }
            },
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            },
            listeElus:{
                id:0,
                prenom:null,
                nom:null,
                roles:{
                    term_id: 0,
                    name: null
                },
                description:null,
                image:{}
            },
            avis:{
                titre_avis: null,
                date_loc: null,
                commentaire_avis: null
            }
        }
    }, 

    created(){
        axios.get(param.hostacf+'bibliotheque-nqd/29000')
        .then(response =>{
        this.Bibliotheque = response.data;
            console.log('Bibliotheque', this.Bibliotheque)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'elu/v1/listeElus')
        .then(response =>{
        this.listeElus = response.data;
            console.log('listeElus', this.listeElus)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            console.log(this.listePages)
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Location salle des fêtes'){
                    console.log(this.listePages[i])
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },    
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Salle-des-fetes.vue